<template>
  <div class="orb">
    <canvas class="orb__canvas no-swipe-nav" />
    <div class="orb__pano no-swipe-nav"></div>
    <div class="orb__preloader no-swipe-nav" :style="{width: loadedPercent, opacity: !loaded ? 1 : 0}"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import create360Viewer from '360-image-viewer';
import { PanoViewer } from '@egjs/view360';
// import canvasFit from 'canvas-fit';

export default {
  name: 'orb',
  computed: {
    ...mapGetters(['page']),
    imageUrl() {
      return this.page.image;
    },
  },
  data() {
    return {
      // canvas: null,
      pano: null,
      image: null,
      viewer: null,
      loadedPercent: 0,
      loaded: false,
    };
  },
  mounted() {
    // this.canvas = this.$el.querySelector('.orb__canvas');

    Image.prototype.onChangeSize; // eslint-disable-line
    Image.prototype.load = (url) => {
      const req = ((XMLHttpRequest) ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP')); //eslint-disable-line
      req.open('GET', url, true);
      req.responseType = 'arraybuffer';
      req.onload = () => {
        if (req.response) {
          const blob = new Blob([req.response]);
          this.src = window.URL.createObjectURL(blob);
        }
      };
      req.onprogress = (e) => {
        if (this.onChangeSize) {
          this.onChangeSize(e.loaded, e.total);
        }
      };
      req.send();
    };
    this.image = new Image();
    this.image.crossOrigin = 'Anonymous';
    this.image.onChangeSize = (loaded, total) => {
      this.loadedPercent = `${parseInt((loaded / total) * 100, 10)}%`;
    };
    this.image.addEventListener('load', this.handleImageLoaded);
    this.image.load(this.imageUrl);
    this.pano = this.$el.querySelector('.orb__pano');
    // console.log(panoViewer);

    // this.image = new Image();
    // this.image.addEventListener('load', this.handleImageLoaded);
    // this.image.crossOrigin = 'Anonymous';
    // this.image.src = this.imageUrl;
    // const image = new Image();
    // image.src = this.image;
  },
  methods: {
    handleImageLoaded() {
      this.loaded = true;
      this.viewer = new PanoViewer(
        this.pano,
        {
          image: this.image,
          gyroMode: 'none',
        },
      );
      // console.log(panoViewer);

      window.addEventListener('resize', () => {
        this.viewer.updateViewportDimensions();
      });
      // const viewer = create360Viewer({
      //   image: this.image,
      //   canvas: this.canvas,
      // });

      // const fit = canvasFit(this.canvas, this.$el);
      // window.addEventListener('resize', fit, false);
      // fit();

      // viewer.start();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../scss/helpers';

.orb {
  @include page;

  &__canvas,
  &__pano {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  &__preloader {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 0;
    transition: width 2s, opacity 1s;
    background: rgba($c_primary, .75);
    pointer-events: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/Orb.vue